<template>

    <MyCards 
        v-if="showMyCards" @closeMyCards="showMyCards = false"
        @deleteCard="deleteCard"
    />

    <showSlideMenu
        :showSlideMenuClass="showSlideMenuClass"
        @removeClass="showSlideMenuClass = false"
        @showBuyTokensFromSideMenu="showBuyTokensFromSideMenu"
        @openFaqs = "openFaqs"
    />

    <Faqs
        v-if="showFaqs"
        @closeFaqs="showFaqs = false"
    />

    <MainNavigation 
        @showUserInfoFromMenu="showUserInfo = true"
        @showLoginWindow="showLoginForm = true"
        @openBuyTokens="showBuyTokens = true"
        @showSlideMenu="showSlideMenuClass = true"
    />

    <UserInfo @hideUserInfo="showUserInfo = false" @openBuyTokens="showBuyTokens = true" v-if="showUserInfo" @openMyCards="showMyCards = true" />

    <component :is="style">
        #playerImage {
            <!-- {{ image.flipImageX ?
                        `transform: scaleX(-1);`:null
                    }} -->
            
            filter: 
                    grayscale({{image.grayscale}}%) 
                    sepia({{image.sepia}})
                    brightness({{image.brightness}})
                    contrast({{image.contrast}})
                    saturate({{image.saturation}})
                    {{ useImageOutline ?
                        `drop-shadow(${imageOutlineWidth}px 0 0 ${imageOutlineColor})  drop-shadow(0 ${imageOutlineWidth}px 0 ${imageOutlineColor})  drop-shadow(-${imageOutlineWidth}px 0 0 ${imageOutlineColor})  drop-shadow(0 -${imageOutlineWidth}px 0 ${imageOutlineColor});`:null
                    }}
                    
        }

        #playerImage-drag-resize .vdr-container {
            transform: scale({{ playerImgResizeFactor }});
        }

    </component>

    <component :is="style" v-if="cardColors.isKeeper">
        #full_card_size, #border-top, #border-bottom, #player-stats-block {
            fill: #BEE2EB;
        }
        #border-left {
            display: none;
        }
    </component>
    <component :is="style" v-if="cardColors.isBalonOro">
        text#dorsal-number {
            fill: #0d0c0f;
        }
        tspan#name-output-span-stroke {
            fill: #0d0c0f;
            stroke: #0d0c0f;
        }
        tspan#name-output-span {
            fill: #eecc75;
        }
    </component>

    <CardProcessing v-if="printBtnclicked" />
    
    <!-- <div class="container">
        <h1>Create your card</h1>
    </div> -->

    <div class="card-creator" :class="{overflowHidden : printBtnclicked}">

        <div class="container">

            <div class="card-creator--settings">

                <div class="nav-showSettingsStep">
                    <div @click="showSettings('showSettingsStep1')" :class="{active : showSettingsStep1}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-card-checklist" viewBox="0 0 16 16">
                            <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2z"/>
                            <path d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0M7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0"/>
                        </svg>
                        <span>Detalles</span>
                    </div>
                    <div @click="showSettings('showSettingsStep2')" :class="{active : showSettingsStep2}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-bounding-box" viewBox="0 0 16 16">
                            <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5M.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5"/>
                            <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
                        </svg>
                        <span>Imagen</span>
                    </div>
                    <div @click="showSettings('showSettingsStep3')" :class="{active : showSettingsStep3}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-sliders2" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M10.5 1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4H1.5a.5.5 0 0 1 0-1H10V1.5a.5.5 0 0 1 .5-.5M12 3.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m-6.5 2A.5.5 0 0 1 6 6v1.5h8.5a.5.5 0 0 1 0 1H6V10a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5M1 8a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 1 8m9.5 2a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V13H1.5a.5.5 0 0 1 0-1H10v-1.5a.5.5 0 0 1 .5-.5m1.5 2.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5"/>
                        </svg>
                        <span>Ajustes</span>
                    </div>
                    <div @click="showSettings('showSettingsStep4')" :class="{active : showSettingsStep4}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-shield-plus" viewBox="0 0 16 16">
                            <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56"/>
                            <path d="M8 4.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V9a.5.5 0 0 1-1 0V7.5H6a.5.5 0 0 1 0-1h1.5V5a.5.5 0 0 1 .5-.5"/>
                        </svg>
                        <span>Escudo</span>
                    </div>
                    <div @click="showSettings('showSettingsStep5')" :class="{active : showSettingsStep5}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-download" viewBox="0 0 16 16">
                            <path d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                            <path d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z"/>
                        </svg>
                        <span>Generar</span>
                    </div>
                </div>

                <div class="card-styles--setting-wrap">

                    <div style="font-size:0.85rem;font-weight: 600;line-height:1;">Al generar la carta desaparecerá nuestro logo.</div>

                    <!-- STEP 1 -->
                    <CardSettingsPlayerstats
                    v-show="showSettingsStep1"
                        :cardColors="cardColors"
                        @generateToplayerImg="generateToplayerImg"
                    />

                    <!-- STEP 2 -->
                    <CardSettingsPlayer
                    v-show="showSettingsStep2"
                        :errorMessage="errorMessage"
                        :imgSrc="imgSrc"
                        :useImageOutline="useImageOutline"
                        :imageOutlineColor = "imageOutlineColor"
                        :imageOutlineWidth = "imageOutlineWidth"
                        :showPreviewPlayerImage="showPreviewPlayerImage"
                        :cardColors="cardColors"
                        @changePlayerImage="uploadImage"
                        @updateInputImageOutline="updateImageOutline"
                        @updateInputImageOutlineWidth = "updateInputImageOutlineWidth"
                        @setOutlineColor = "setOutlineColor"
                        @useCroppedImageFromPlayer="uploadImage"
                        @cancelPlayerImage="cancelPlayerImageParent"
                        @triggerNoBg="noBgFn"
                        @updateGrayscale="updateGrayscale"
                        @updateSepia="updateSepia"
                        @updateBrightness="updateBrightness"
                        @updateContrast="updateContrast"
                        @updateSaturation="updateSaturation"
                        @updateflipHorizontal="updateflipHorizontal"
                        @open-modal-toolarge-image = "imageIsTooLarge = true"
                        :imageIsTooLarge="imageIsTooLarge"
                        @playerImgResizeFactorChange="playerImgResizeFactor = $event"
                        :playerImgResizeFactor="playerImgResizeFactor"
                    />

                    <!-- STEP 3 -->
                    <CardSettingsStyles
                        ref="CardSettingsStyles"
                        v-show="showSettingsStep3"
                        :cardColors="cardColors"
                        @checkForSavedTemplates="checkForSavedTemplates"
                    />

                    <!-- STEP 4 -->
                    <CardSettingsEscudo
                    v-show="showSettingsStep4"
                        :errorMessageEscudo="errorMessageEscudo"
                        @changeEscudoImage="uploadImageEscudo"
                    />

                    <!-- STEP 5 -->
                    <div class="card-styles--setting card-styles--printimg" v-show="showSettingsStep5">
                        <h2>5. Generar Carta</h2>
                        <p>Generar la carta y descargarla te <span class="underline_span">costará 1 ficha</span> de tu saldo.
                        Revisa tu carta, después de generada no se podrán realizar cambios. 
                            Podrás acceder a tu carta y volver a descargar accediendo a la sección 'Mis Cartas'(click en tu icono de sesión).</p>

                        <div class="generate-img-btn" v-if="cardColors.playerImageLink">
                            <button class="button1" @click="printImg" v-if="this.$store.state.user.availableTokens > 0">
                                <span>Crear Carta</span>
                               
                                <svg class="token-ficha--svg" width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000">
                                    <g stroke="none" stroke-width="1" fill-rule="evenodd">
                                        <g id="token-ficha">
                                            <path d="M20,40 C8.954305,40 0,31.045695 0,20 C0,8.954305 8.954305,0 20,0 C31.045695,0 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 Z M20,36 C28.836556,36 36,28.836556 36,20 C36,11.163444 28.836556,4 20,4 C11.163444,4 4,11.163444 4,20 C4,28.836556 11.163444,36 20,36 Z" id="token-combi"></path>
                                            <polygon id="Star" points="19.839263 28 11.9041621 32.3262379 13.4196315 23.163119 7 16.6737621 15.8717125 15.336881 19.839263 7 23.8068134 15.336881 32.6785259 16.6737621 26.2588945 23.163119 27.7743639 32.3262379"></polygon>
                                        </g>
                                    </g>
                                </svg>

                            </button>
                            <button class="button1" v-else @click="showBuyTokens = true">Crear Carta</button>
                            <div v-if="this.$store.state.user.availableTokens <= 0">
                                Saldo de fichas insuficiente.
                            </div>

                        </div>
                    </div>

                </div>

                

            </div>

            

            <div class="card-creator--preview">
                
                <div class="parentWindow" :class="{showWatermark : !showWatermark}">

                    <div class="card-wrap">
                        <div id="card" class="card" :class="{imageBeingEdited : active, printBtnclicked : printBtnclicked, escudoBeingEdited : activeEscudo}" @click="modifyImg">
                            
                            <!-- START // TO TRIGGER IMAGE RESIZE EVENTS START ON CLICK -->
                            <svg id="activate-card--images" width="630px" height="890px" viewBox="0 0 630 890" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-1133.000000, -1671.000000)">
                                    <g id="Group-2" transform="translate(1133.000000, 1671.000000)" fill="#D8D8D8">
                                        <polygon @click="activatePlayerImg" id="activate--player-image" points="0 210.291636 510.842898 78.1231531 510.842898 0 630 0 630 890 0 890"></polygon>
                                        <polygon @click="activateEscudoImg" id="activate--escudo-image" points="0 0 507 0 507 70.6872891 0 205.126265"></polygon>
                                    </g>
                                </g>
                            </svg>
                            <!-- END // TO TRIGGER IMAGE RESIZE EVENTS START ON CLICK -->

                            <!-- START // WATERMARK -->
                            <WatermarkCard
                                v-show="showWatermark"
                                ref="watermark"
                            />
                            
                            <!-- START // COLORS OF OUR CARD -->
                            <Bottomlayersvg
                                v-if="!cardColors.isKeeper && !cardColors.isBalonOro"
                                :cardColors="cardColors"
                            />

                            <!-- keeper bottom layer -->
                            <KeeperBottomLayer 
                                v-if="cardColors.isKeeper"
                            />

                            <!-- oro bottom layer -->
                            <OroBottomLayer
                                v-if="cardColors.isBalonOro"
                            />
                            



                            <div id="playerImage-drag-resize">
                                <!-- START // PLAYER IMAGE -->
                                <Vue3DraggableResizable
                                    :initW="initWValue"
                                    :initH="initHValue"
                                    :lockAspectRatio="true"
                                    v-model:x="x"
                                    v-model:y="y"
                                    v-model:w="w"
                                    v-model:h="h"
                                    v-model:active="active"
                                    :draggable="true"
                                    :resizable="false"
                                    @activated="print('activated')"
                                    @deactivated="print('deactivated')"
                                    :handles="['tl','tr','bl','br']"
                                    classNameHandle="player-handle"
                                    
                                >
                                    <img v-if="cardColors.playerImageLink" :src="cardColors.playerImageLink" style="width: 100%; height: 100%" class="image" id="playerImage"  :class="{useImageOutline : useImageOutline}" />

                                </Vue3DraggableResizable>
                            </div>

                            <!-- START // ESCUDO IMAGE -->
                            <div id="escudo-wrapper">
                                <Vue3DraggableResizable
                                    :parent="true"
                                    :initW="initWValueEscudo"
                                    :initH="initHValueEscudo"
                                    :lockAspectRatio="true"
                                    v-model:x="xEscudo"
                                    v-model:y="yEscudo"
                                    v-model:w="wEscudo"
                                    v-model:h="hEscudo"
                                    v-model:active="activeEscudo"
                                    :draggable="true"
                                    :resizable="true"
                                    @activated="print('activated')"
                                    @deactivated="print('deactivated')"
                                    :handles="['tl','tr','bl','br']"
                                    classNameHandle="escudo-handle"
                                >
                                    <img v-if="cardColors.escudoImageLink" :src="cardColors.escudoImageLink" style="width: 100%; height: 100%" />
                                </Vue3DraggableResizable>
                            </div>

                            <!-- START // PLAYER INFO: NAME AND STATS -->
                            <Toplayersvg
                                id="card-top-layer-svg"
                                :cardColors="cardColors"
                                ref="card-top-layer-svg"
                            />

                        </div>
                    </div>
                </div>
                

                

                <!-- <div class="Toplayersvg-output">
                    <img :src="toplayerImg" />
                </div> -->

                
            </div>

        </div>

    </div>



    

    <div class="tab-menu" style="display: none;">

        <!-- START main settings tabs DETALLES -->
        <TabsMainDetalles 
            v-if="mainTabActive === 'detalles'"
            :cardColors="cardColors"
        />

        <!-- START main settings tabs IMAGEN -->
        <TabsMainImagen
            v-if="mainTabActive === 'imagen'"
            @changePlayerImage="uploadImage"
            @triggerNoBg="noBgFn"
            @updateInputImageOutlineMobile="updateImageOutline"
            @updateInputImageOutlineWidth = "updateInputImageOutlineWidth"
            :useImageOutline="useImageOutline"
            :playerImageLink = "cardColors.playerImageLink"
        />

        <!-- START main settings tabs ESTILOS -->
        <TabsMainEstilos
            v-if="mainTabActive === 'estilos'"
            @showMainSetting="mainTabSetting = $event"
        />

        <!-- START main settings tabs ESCUDO -->
        <TabsMainEscudo
            v-if="mainTabActive === 'escudo'"
            @showMainSetting="mainTabSetting = $event"
        />
 
        <!-- START main tabs always visible at bottom -->
        <TabsMain
            @showMainTab = 'mainTabActive = $event'
        />
        <!-- END main tabs always visible at bottom -->

    </div>


    <CardDownloadLink
        :imageDataUrl="imageDataUrl"
        :cardColors="cardColors"
        :readyForDownload="readyForDownload"
        v-show="readyForDownload"
        @close-modal = "readyForDownload = false"
    />

    <LoginSignUp 
        v-if="showLoginForm"
        @closeLoginForm="showLoginForm = false"
        @getTemplatesFromDb = "getTemplatesFromDb"
        @updateMisCartas="updateMisCartas"
        @addDataLocalStorage="addDataLocalStorage"
    />

    <BuyTokens
        v-if="showBuyTokens"
        @closeBuyTokens="showBuyTokens = false"
        @openLoginWindow="showLoginForm = true"
        @addToSessionStorage="addToSessionStorage"
    />

    


</template>

<script>

import axios from 'axios';

import MainNavigation from './components/MainNavigation.vue'
import UserInfo from './components/UserInfo.vue'

import TabsMain from './components/TabsMain.vue'
import TabsMainDetalles from './components/TabsMainDetalles.vue'
import TabsMainImagen from './components/TabsMainImagen.vue'
import TabsMainEstilos from './components/TabsMainEstilos.vue'
import TabsMainEscudo from './components/TabsMainEscudo.vue'
import showSlideMenu from './components/SlideMenu.vue'

import MyCards from './components/MyCards.vue';
import Faqs from './components/Faqs.vue'



import Vue3DraggableResizable from 'vue3-draggable-resizable'
import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'

// import VueCropper from 'vue-cropperjs';
// import 'cropperjs/dist/cropper.css';


import CardProcessing from './components/CardProcessing.vue'
import CardSettingsPlayer from './components/CardSettingsPlayer.vue'
import CardSettingsPlayerstats from './components/CardSettingsPlayerstats.vue'
import CardSettingsStyles from './components/CardSettingsStyles.vue'
import CardSettingsEscudo from './components/CardSettingsEscudo.vue'
import Bottomlayersvg from './components/Bottomlayersvg.vue'
import Toplayersvg from './components/Toplayersvg.vue'
import WatermarkCard from './components/WatermarkCard.vue'
import CardDownloadLink from './components/CardDownloadLink.vue'
// import PreviewPlayerImage from './components/PreviewPlayerImage.vue'
import ModalimageTooLarge from './components/ModalimageTooLarge.vue'

import LoginSignUp from './components/LoginSignUp.vue';
import BuyTokens from './components/BuyTokens.vue';
import SvgLogo from './components/SvgLogo.vue';
import OroBottomLayer from './components/OroBottomLayer.vue'
import KeeperBottomLayer from './components/KeeperBottomLayer.vue';



export default {
  name: 'App',

        data() {
            return {
                showSettingsStep1: true,
                showSettingsStep2: false,
                showSettingsStep3: false,
                showSettingsStep4: false,
                showSettingsStep5: false,

                deteteCardConfirmed: false,
                showFaqs: false,
                showSlideMenuClass: false,
                watermarkExists: true,
                showMyCards: false,
                showBuyTokens: false,
                showLoginForm: false,
                hideAll: true,

                mainTabActive: 'detalles',
                mainTabSetting: null,

                playerImgResizeFactor : 1,
                showUserInfo: false,
                helloMsg: '',

                toplayerImg: '',

                imageIsTooLarge: false,

                imgSrc: '',
                cropImg: '',
                data: null,
                // cropperReady: false,
                // cropperSettings: {
                //     viewMode: 1, 
                //     dragMode: 'move', 
                // },
                croppedImage: null,
                showPreviewPlayerImage: false,
                showSetting: 'playerStats',
                useImageOutline: false,
                imageOutlineWidth: 1,
                imageOutlineColor: '#fff',
                errorMessage: '',
                errorMessageEscudo: '',
                style: 'style',
                x: 0,
                y: 0,
                h: 100,
                w: 100,
                initWValue: 293,
                initHValue : 439,
                active: false,

                xEscudo: 7,
                yEscudo: 0,
                hEscudo: 60,
                wEscudo: 35.5,
                initWValueEscudo: 35.5,
                initHValueEscudo : 60,
                activeEscudo: false,

                readyForDownload: false,

                showWatermark: true,
                watermarkHidden: false,

                sohaibImg: '',
                
                printBtnclicked: false,
                imageDataUrl: 'javascript:;',
                image: {
                    grayscale: 0,
                    sepia: 0,
                    brightness: 1,
                    contrast: 1,
                    saturation: 1,
                    flipImageX: false
                },
                cardColors: {
                    trapColors1 : '#FFD500',
                    trapColors2: '#FCB806',
                    trapBorder: '#8F1B2E',
                    backgroundMask: '#8F1B2E',
                    playerName: 'Nombre',
                    attackValue: 100,
                    midfieldValue: 100,
                    defenseValue: 100,
                    playerPosition: 'attack',
                    playerDorsal: 10,
                    backgroundLinesColorOpacity: 1,
                    backgroundLinesColor: '#C2345A',
                    playerImageLink: '',
                    escudoImageLink: '',
                    isKeeper: false,
                    isBalonOro: false
                }
                
            }
        },


        components: {
            showSlideMenu,
            MainNavigation,
            UserInfo,
            Vue3DraggableResizable,
            CardProcessing,
            CardSettingsPlayer,
            CardSettingsPlayerstats,
            CardSettingsStyles,
            CardSettingsEscudo,
            Bottomlayersvg,
            Toplayersvg,
            WatermarkCard,
            CardDownloadLink,
            ModalimageTooLarge,
            TabsMain,
            TabsMainDetalles,
            TabsMainImagen,
            TabsMainEstilos,
            TabsMainEscudo,
            LoginSignUp,
            BuyTokens,
            SvgLogo,
            OroBottomLayer,
            KeeperBottomLayer,
            MyCards,
            Faqs
        },

        mounted() {

        },

        methods: {

            showSettings(settingToShow) {

                for(let i = 1; i < 6; i++) {
                    this['showSettingsStep'+i] = false;
                }
                this[settingToShow] = true;
            },


            deleteCard(data) {
                console.log(data);

                let imageToRemoveString = data.lastIndexOf('/');
                let imageToRemove = '';

                // Check if a "/" was found
                if (imageToRemoveString !== -1) {
                    const substringAfterLastSlash = data.substring(imageToRemoveString + 1);

                    imageToRemove = substringAfterLastSlash;
                }
  
                const formData = new FormData();
                formData.append('image', imageToRemove);
                let vm = this;
                axios.post('https://www.cartafutbol.com/api/v1/Card/removeCard.php', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': `Bearer ${this.$store.state.user.tokenId}`
                        },
                    })
                    .then(response => {
                        console.log('Image deleted successfully:', response.data);
                        vm.updateMisCartas();
                        })
                    .catch(error => {
                        console.error('Error deleting image:', error);
                    });

            },

            closeSlideMenu() {
                this.showSlideMenuClass = false;
            },

            openFaqs() {
                this.showFaqs = true;
                this.closeSlideMenu();
            },

            showBuyTokensFromSideMenu() {
                this.showBuyTokens = true;
                this.closeSlideMenu();
            },

            showSlideMenu() {
                alert('we will show extra menu')
            },

            async getTemplatesFromDb() {
            
                // console.log(`templates: ${this.$store.state.user.savedTemplates}`);
                const response = await axios.get(
                    'https://www.cartafutbol.com/api/v1/Template/getTemplates.php',
                    {headers: {
                        'Authorization': `Bearer ${this.$store.state.user.tokenId}`
                    }},
                );

                if(response.data.templates.templates != undefined || response.data.templates.templates != null) {
                    this.$store.state.user.savedTemplates = response.data.templates.templates;
                }
                
                // call method from child component
                this.$refs.CardSettingsStyles.checkForSavedTemplates();

            },

            async fetchUserData() {
                try {
                    // Make the GET request using Axios
                    const response = await axios.get('https://wwww.cartafutbol.com/api/v1/Template/getTemplates.php');

                    // Check the response from the server
                    if (response.data.success) {
                        // Handle success: Process the fetched data
                        console.log('Data fetched successfully:', response.data);
                    } else {
                        // Handle failure: Data fetching failed
                        console.error('Data fetching failed. Reason:', response.data.message);
                    }
                } catch (error) {
                    // Handle error: Something went wrong with the request
                    console.error('An error occurred while fetching data.', error);
                }
            },

           
            showMainSetting(setting){
                console.log(setting)
                // this.mainTabSetting = setting;
            },

            showMainTab(tab) {
                this.mainTabActive = tab;
            },
   
            // method worth considering to output an image instead of svg!!!
            generateToplayerImg() {
                var svg = this.$refs['card-top-layer-svg'].$el;
                var svgData = new XMLSerializer().serializeToString(svg);

                var canvas = document.createElement("canvas");
                var ctx = canvas.getContext("2d");

                var img = document.createElement("img");
                img.setAttribute("src", "data:image/svg+xml;base64," + btoa(svgData));

                var vm = this;

                img.onload = function() {
                    // Set canvas dimensions to match the SVG
                    canvas.width = svg.width.baseVal.value;
                    canvas.height = svg.height.baseVal.value;

                    ctx.drawImage(img, 0, 0);
                    vm.toplayerImg = canvas.toDataURL("image/png");
                };
            },

            activatePlayerImg() {
                console.log('player image works');
                if(this.cardColors.playerImageLink !== '') {
                    this.active = true;
                }
                
            },

            activateEscudoImg() {
                if(this.cardColors.escudoImageLink !== '') {
                    this.activeEscudo = true;
                }
            },

            updateflipHorizontal(data){
                this.image.flipImageX = data
            },

            updateSaturation(data) {
                this.image.saturation = data;
            },

            updateContrast(data) {
                this.image.contrast = data;
            },

            updateBrightness(data) {
                this.image.brightness = data;
            },

            updateGrayscale(data) {
                this.image.grayscale = data;
            },

            updateSepia(data) {
                this.image.sepia = data;
            },

            cancelPlayerImageParent() {
                this.imgSrc = this.cardColors.playerImageLink;
                this.showPreviewPlayerImage = false;
                
                setTimeout(()=>{
                    this.showPreviewPlayerImage = true;
                },100)
                
            },

            updateImageOutline(data) {
                this.useImageOutline = data
            },

            updateInputImageOutlineWidth(data) {
                this.imageOutlineWidth = data
            },

            setOutlineColor(data) {
                this.imageOutlineColor = data
            },

            noBgFn() {
                let vm = this;
                this.showPreviewPlayerImage = false;
                vm.printBtnclicked = true;
                let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: 'https://www.cartafutbol.com/rembg/api.php',
                        headers: { 
                            'Content-Type': 'multipart/form-data',
                        },
                        data : vm.sohaibImg
                        };

                        axios.request(config)
                        .then((response) => {
                            console.log(response)
                            console.log(response.data)
                            function toDataURL(src, callback, outputFormat) {
                                let image = new Image();
                                image.crossOrigin = 'Anonymous';
                                image.onload = function () {
                                    let canvas = document.createElement('canvas');
                                    let ctx = canvas.getContext('2d');
                                    let dataURL;
                                    canvas.height = this.naturalHeight;
                                    canvas.width = this.naturalWidth;
                                    ctx.drawImage(this, 0, 0);
                                    dataURL = canvas.toDataURL(outputFormat);
                                    callback(dataURL);
                                };
                                image.src = src;
                                vm.showPreviewPlayerImage = true;
                                if (image.complete || image.complete === undefined) {
                                    image.src = "data:image/gif;base64, R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
                                    image.src = src;
                                    
                                }
                            }

                                
                            toDataURL(response.data.image,
                                function (dataUrl) {
                                    vm.cardColors.playerImageLink = dataUrl;
                                }
                            )
                            vm.printBtnclicked = false;   
                        
                        })
                        .catch((error) => {
                        console.log(error);
                        });
            },

            
            modifyImg() {
                if(this.showSetting === 'player') {
                    this.active = true;
                }

                if(this.showSetting === 'club') {
                    this.activeEscudo = true;
                }
            },  
           
            activeSetting(tab) {
                this.showSetting = tab;
            },

            openFileInput() {

                this.$refs.fileInput.click();
            },

            uploadImage(playerFile) {
                this.imageIsTooLarge = false;
                if(playerFile.size > 5 * 1024 * 1024) {
                    console.log('we need to set var to too large')
                    this.imageIsTooLarge = true;
                }

                let vm = this;
                this.showPreviewPlayerImage = false;
                // const file = event.target.files[0];
                const file = playerFile;

                if (file) {

                    if (file.type.startsWith('image/')) {

                        let formData = new FormData();
                        
                        formData.append('image', file);


                        let data = new FormData();
                        data.append('image', file);

                        data.append('image', file);

                        vm.sohaibImg = data;


 
                    const reader = new FileReader();

                    reader.onload = (e) => {

                        const img = new Image();

                        // before assigning the source to the final element
                        // it needs be displayed in the preview window

                        // assign the image if accepted here
                        img.src = e.target.result;
                        img.onload = () => {
                        this.x = 0;
                        this.y = 0;

                        let calcH = img.width / 300;
                        
                        this.w = 300;
                        this.h = img.height / calcH;

                        this.imgSrc = e.target.result;

                        this.cardColors.playerImageLink = e.target.result;

                        
                        this.errorMessage = ''; // Clear any previous error messages
                        this.showPreviewPlayerImage = true; // Show the preview
                        };
                    };
                    reader.readAsDataURL(file);
                    } else {
                    this.errorMessage = 'Invalid file type. Please select an image.';
                    }
                }
            },

            addToSessionStorage(){

                if (this.isLocalStorageSupported()) {

                    let userSessionInfo = {
                        w: this.w,
                        h: this.h,
                        src: this.imgSrc,
                        x: this.x,
                        y: this.y,
                        trapColors1 : this.cardColors.trapColors1,
                        trapColors2: this.cardColors.trapColors2,
                        trapBorder: this.cardColors.trapBorder,
                        backgroundMask: this.cardColors.backgroundMask,
                        playerName: this.cardColors.playerName,
                        attackValue: this.cardColors.attackValue,
                        midfieldValue: this.cardColors.midfieldValue,
                        defenseValue: this.cardColors.defenseValue,
                        playerPosition: this.cardColors.playerPosition,
                        playerDorsal: this.cardColors.playerDorsal,
                        backgroundLinesColorOpacity: this.cardColors.backgroundLinesColorOpacity,
                        backgroundLinesColor: this.cardColors.backgroundLinesColor,
                        playerImageLink: this.cardColors.playerImageLink,
                        escudoImageLink: this.cardColors.escudoImageLink,
                        isKeeper: this.cardColors.isKeeper,
                        isBalonOro: this.cardColors.isBalonOro,
                        
                        xEscudo: this.xEscudo,
                        yEscudo: this.yEscudo,
                        hEscudo: this.hEscudo,
                        wEscudo: this.wEscudo,


                        grayscale: this.image.grayscale,
                        sepia: this.image.sepia,
                        brightness: this.image.brightness,
                        contrast: this.image.contrast,
                        saturation: this.image.saturation,
                        flipImageX: this.image.flipImageX

                    };

                    sessionStorage.setItem("cartaFutbol__user", JSON.stringify(userSessionInfo));

                    console.log('sessionstorage set');

                } else {
                    console.warn('cannot use session storage for this browser/user')
                }

                



            },

            usePlayerImage() {

            // Handle the "Use Image" button click
            // You can perform further actions here, e.g., save the selected image
            // or update your application's state with the selected image URL.
            // this.showPreviewPlayerImage = false; // Close the preview
            },
            closePreview() {
                console.log('we want to close')
            // Handle the "Cancel" button click
            // This function should close the preview without taking any action.
            // this.showPreviewPlayerImage = false;
            if(this.cardColors.playerImageLink) {

            }
            this.cardColors.playerImageLink = ''; // Clear the preview image
            },
            uploadImageEscudo(escudoFile) {
            const file = escudoFile; // Get the selected file
            if (file) {
                // Check if the selected file is an image
                if (file.type.startsWith('image/')) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    // Create an Image object to get the initial width and height
                    const img = new Image();
                    img.src = e.target.result;
                    img.onload = () => {
                    this.xEscudo = 0;
                    this.yEscudo = 0;
                    // Update the initial width and height properties
                    let calcH = img.height / 75;
                    
                    this.wEscudo = img.width / calcH;
                    this.hEscudo = 75;

                    // Update the image source with the selected image URL
                    this.cardColors.escudoImageLink = e.target.result;

                    
                    this.errorMessageEscudo = ''; // Clear any previous error messages
                    };
                };
                reader.readAsDataURL(file);
                } else {
                this.errorMessageEscudo = 'Invalid file type. Please select an image.';
                }
            }
            },
            mainImageActive() {
                this.active = true
            },
            escudoImageActive() {
                this.activeEscudo = true
            },
            print(val) {
                console.log(val)
            },

            async getTokensBackend() {
                const response = await axios.get(
                    'https://www.cartafutbol.com/api/v1/User/availableTokens.php',
                    {headers: {
                        'Authorization': `Bearer ${this.$store.state.user.tokenId}`
                    }},
                );

                let tokens = response.data.availableTokens;
                this.$store.state.user.availableTokens = tokens;
                console.log('tokens: ',tokens);

                return tokens;
            },

            async sendImageToBackend() {

                const element = document.getElementById('card');

                let vm = this;

                // Use dom-to-image to convert the element to a Blob
                domtoimage.toBlob(element, { height: 1335, width:945 })
                .then(blob => {
                    // Create FormData to send the Blob as a file
                    const formData = new FormData();
                    formData.append('image', blob, 'image.png');

                    // Send the Blob to the backend using Axios
                    axios.post('https://www.cartafutbol.com/api/v1/Card/saveCard.php', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': `Bearer ${this.$store.state.user.tokenId}`
                        },
                    })
                    .then(response => {
                        console.log('Image saved successfully:', response.data);
                        this.$store.state.user.availableTokens = response.data.availableTokens;
                        vm.updateMisCartas();
                        })
                    .catch(error => {
                        console.error('Error saving image:', error);
                    });
                })
                .catch(error => {
                    console.error('Error converting element to Blob:', error);
                });

            },

            async printImg(){

                let isLoggedIn = this.$store.state.loggedIn;
                
                if(!isLoggedIn) {
                    alert('You need to log in first');
                    this.showLoginForm = true;
                    return true;
                }

                let tokensAvailable = await this.getTokensBackend();

                this.showWatermark = false;
                const vm = this;
                vm.printBtnclicked = true;

                
                var cardToPrint = document.getElementById('card');


                    let printBtnclicked = this.printBtnclicked;

                    
                    domtoimage
                        .toPng(cardToPrint, { height: 1335, width:945 })
                        .then(function (dataUrl) {
                            var img = new Image();
                            img.src = dataUrl;
                            console.log(dataUrl)
                            vm.imageDataUrl = dataUrl;
                            
                            document.querySelector('#imageOutput').appendChild(img);
                            setTimeout(()=> {
                                vm.printBtnclicked = false;
                                vm.readyForDownload = true;
                                vm.showWatermark = true;
                            },2000);
                            vm.sendImageToBackend();
                        })
                        .catch(function (error) {
                            console.error('oops, something went wrong!', error);
                        });
                    
                        

                

                
            },

            async updateMisCartas() {

                const response = await axios.get(
                    'https://www.cartafutbol.com/api/v1/Card/getCards.php',
                    {headers: {
                        'Authorization': `Bearer ${this.$store.state.user.tokenId}`
                    }},
                );

                console.log(response.data);

                if(response.data.cards != undefined || response.data.cards != null) {
                    this.$store.state.createdCards = response.data.cards;
                }
  

            },

            addDataLocalStorage() {
                
                if (this.isLocalStorageSupported()) {

                    
                    const cartaUser = {
                        userName: this.$store.state.user.userName,
                        email: this.$store.state.user.email,
                        tokenId: this.$store.state.user.tokenId,
                    };

                    localStorage.setItem("cartaFutbol__user", JSON.stringify(cartaUser));
                    console.log('localstorage set')

                } else {
                    console.warn("localStorage is not supported in this browser");
                }


            },
            isLocalStorageSupported() {
                try {
                    localStorage.setItem("__test__", "__test__");
                    localStorage.removeItem("__test__");
                    return true;
                } catch (e) {
                    return false;
                }
            },
            
                

           
        },

        mounted() {
            // Check if localStorage is supported
            if (this.isLocalStorageSupported()) {
                // Check if a user object is stored in localStorage
                const storedUser = localStorage.getItem("cartaFutbol__user");

                if (storedUser) {
                    // Parse the stored JSON string to an object
                    const userObject = JSON.parse(storedUser);

                    // Set the user state in the Vuex store or wherever you manage user state
                    this.$store.state.user.userName = userObject.userName;
                    this.$store.state.user.email = userObject.email;
                    this.$store.state.user.tokenId = userObject.tokenId;
                    // this.$store.state.user.savedTemplates = userObject.savedTemplates;
                    // this.$store.state.createdCards = userObject.createdCards;
                    this.$store.state.loggedIn = true;

                    this.getTokensBackend();

                    // get user templates
                    this.getTemplatesFromDb();

                    // get user saved cards
                    this.updateMisCartas();

                    console.log("User loaded from localStorage:", userObject);
                }

                const sessionUser = sessionStorage.getItem("cartaFutbol__user");
                if(sessionUser) {
                    let sessionData = JSON.parse(sessionUser);

                    this.w = sessionData.w;
                    this.h = sessionData.h;
                    this.imgSrc = sessionData.imgSrc;
                    this.x = sessionData.x;
                    this.y = sessionData.y;
                    this.cardColors.trapColors1 = sessionData.trapColors1;
                    this.cardColors.trapColors2 = sessionData.trapColors2;
                    this.cardColors.trapBorder = sessionData.trapBorder;
                    this.cardColors.backgroundMask = sessionData.backgroundMask;
                    this.cardColors.playerName = sessionData.playerName;
                    this.cardColors.attackValue = sessionData.attackValue;
                    this.cardColors.midfieldValue = sessionData.midfieldValue;
                    this.cardColors.defenseValue = sessionData.defenseValue;
                    this.cardColors.playerPosition = sessionData.playerPosition;
                    this.cardColors.playerDorsal = sessionData.playerDorsal;
                    this.cardColors.backgroundLinesColorOpacity = sessionData.backgroundLinesColorOpacity;
                    this.cardColors.backgroundLinesColor = sessionData.backgroundLinesColor;
                    this.cardColors.playerImageLink = sessionData.playerImageLink;
                    this.cardColors.escudoImageLink = sessionData.escudoImageLink;
                    this.cardColors.isKeeper = sessionData.isKeeper;
                    this.cardColors.isBalonOro = sessionData.isBalonOro;

                    this.xEscudo = sessionData.xEscudo;
                    this.yEscudo = sessionData.yEscudo;
                    this.hEscudo = sessionData.hEscudo;
                    this.wEscudo = sessionData.wEscudo;
                    this.image.grayscale = sessionData.grayscale;
                    this.image.sepia = sessionData.sepia;
                    this.image.brightness = sessionData.brightness;
                    this.image.contrast = sessionData.contrast;
                    this.image.saturation = sessionData.saturation;
                    this.image.flipImageX = sessionData.flipImageX

                } else {
                    console.log('no session stored here')
                }

            } else {
                console.warn("localStorage is not supported in this browser");
            }
        },

        // computed: {
        //     getUserTokens(){
        //         if(this.$store.state.user.availableTokens > 0 && this.$store.state.user.availableTokens != null && this.$store.state.user.availableTokens != undefined) {
        //             return true;
        //         } else {
        //             return false;
        //         }
                
        //     }
        // }


      
        

    }

</script>

<style lang="less">

    @font-face {
    font-family: 'Limelight';
    src: url('./assets/fonts/Limelight-Regular.woff2') format('woff2'),
        url('./assets/fonts/Limelight-Regular.woff') format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
    }

    @font-face {
        font-family: 'Impact';
        src: url('./assets/fonts/Impact.woff2') format('woff2'),
            url('./assets/fonts/Impact.woff') format('woff');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Nunito Sans';
        src: url('./assets/fonts/NunitoSans-ExtraBold.woff2') format('woff2'),
            url('./assets/fonts/NunitoSans-ExtraBold.woff') format('woff');
        font-weight: bold;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Nougat';
        src: url('./assets/fonts/Nougat-ExtraBlack.woff2') format('woff2'),
            url('./assets/fonts/Nougat-ExtraBlack.woff') format('woff');
        font-weight: 900;
        font-style: normal;
        font-display: swap;
    }

    body {
        font-family: var(--base-font);
        font-weight: 400;
        background-color: var(--body_bg);
        color: #333;
        font-size: 16px;
        line-height: 1.6; 
        // background: url(./assets/futbg.jpg) center bottom/cover fixed;
    }

    a {
        color: var(--blue_main);
        text-decoration: none;
    }

    h1 {
        font-size: 2.5rem;
        text-transform: var(--title_transform);
        color: var(--title_color);
        font-family: var(--title_font);
        font-weight: var(--title_weight);
    }

    h2 {
        font-size: 1.65rem;
        text-transform: var(--title_transform);
        color: var(--input_bg);
        color: var(--title_color);
        font-family: var(--title_font);
        margin-bottom: 2rem;
        padding-bottom: 1rem;
        position: relative;
        display: flex;
        align-items: center;
        font-weight: var(--title_weight);

        &::after {
            content: '';
            background: linear-gradient( 90deg, #f1f1f1 30%, transparent 30%, transparent 75%, #f1f1f1 75% );
            width: 100%;
            height: 1.2rem;
            flex: 1;
            margin-left: 1rem;
            background-size: 0.5rem;
            transform: skew(-30deg,0);
            background-position-x: right;
        }
    }

    h4 {
        font-weight: 700;
        margin-bottom: 1.5rem;
        font-size: 1.25rem;
    }

    .card-creator--dashboard {
        color: red;
    }

    #escudo-wrapper {
        width: 170px;
        height: 75px;
        background: none;
        position: absolute;
        top: 12px;
        left: 15px;
    }

    #escudo-wrapper img {
        /* width: auto;
        max-height: 75px; */
        width: 100%;
        height: 100%;
    }
    .parentWindow {
        width: 100%; 
        position: relative; 
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2rem 1rem;
        border-radius: var(--radius_global);
        background-color: var(--light_blue);
        border: 4px solid var(--extralight_blue);
        background-color: transparent;
        border-color: transparent;
        // background: url(./assets/shines.png) center top/contain  no-repeat;
    }

    .card {
        width: 315px;
        height: 445px;
        overflow: hidden;
        position: relative;
    }

    .card.escudoBeingEdited #escudo-wrapper {
        z-index: 20;
    }

    .card.imageBeingEdited img {
        opacity: 1;
        position: relative;
        z-index: 11;
    }

    .vdr-handle-tr,
    .vdr-handle-bl {
        cursor: nesw-resize;
    }

    .vdr-handle-tl,
    .vdr-handle-br {
        cursor: nwse-resize;
    }

    .vdr-handle {
        z-index: 100;
        border-radius: 50%;
        background: var(--button_gradient_orange);
        border-color: transparent;
    }

    .vdr-container.active {
        border-color: lightblue;
        z-index: 12;
        cursor: move;
    }

    .card.printBtnclicked {
        transform: scale(3);
        transform-origin: left top;
        border: 0;
    }

    rect#bg-to-hide {
        display: none;
    }



    #imageOutput {
        position: relative;
        box-sizing: border-box;
        display: none;
    }

    #imageOutput img {
        max-width: 100%;
    }

    * {
        box-sizing: border-box;
    }





    .container {
        max-width: 1250px;
        margin: 2rem auto;
        padding: 0 1rem;
    }

    .card-creator .container {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }

    .card-creator .container > div {
        border-radius: 4px;
    }

    .card-creator--settings {
        width: calc(70% - 1rem);
        padding: 0rem 3rem 0 0;
        border: 0;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
    }

    .card-creator--preview {
        width: calc(30% - 1rem);
        z-index: 5;
        position: sticky;
        top: 0;
    }

    

    button {
        color: var(--dark_blue);
        padding: var(--button_paddingy) var(--button_paddingx);
        border-radius: var(--radius_global);
        cursor: pointer;
        font-family: var(--base-font);
        font-weight: 700;
        border: 0;
        font-size: 0.8rem;
        position: relative;
        overflow: hidden;
        text-transform: var(--button_transform);
        background: #efefef;

        &.button1 {
            background: var(--blue_main);
            color: var(--button1_color);
            border: var(--button1_border);

            &:hover {
                background: var(--button1_hoverbg);
                color: var(--blue_main);
            }   
        }

        &.button2 {
            color: var(--blue_main);

            &:hover {
                background: var(--blue_ultralight);
            }
        }

        &.button3 {
            background: var(--blue_ultralight);

            &:hover {
                background: var(--blue_main);
                color: white;
            }
        }

        &.button4 {
            background: none;
        }


        &::before {
            content: '';
            width: 50px;
            height: 100%;
            position: absolute;
            left: -50px;
            top: 0;
            background: rgba(255,255,255,0.15);
            background: rgb(255,255,255);
            background: linear-gradient(90deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0.05) 100%);
            
            transform: skew(15deg)
        }
    }

    button:hover::before {
        animation: buttonHover 1.5s ease infinite;
    }

    @keyframes buttonHover {
        0% {
            left: -50px;
            opacity: 0;
        } 
        
        50% {
            opacity: 1;
        }

        100% {
            left: calc(100% + 50px);
            opacity: 0;
        }
    }

    .card-styles--setting {
        margin: 0rem auto 1rem;
        padding: 2rem 0rem 2rem;
        border-radius: 4px;
    }

    .card-styles--setting-wrap {
        flex: 1;
        width: 100%;
        border-radius: var(--radius_global);
        border: 2px solid rgba(0,0,0,0.3);
        background: none;
        border: 0;

        & > div {
            border-radius: var(--radius_global);
            padding: 2rem;
            background: var(--light_blue);
            overflow: hidden;
            position: relative;
            margin-bottom: 3rem;
            border-top: 5px solid var(--extralight_blue);
            border: 0;
            background: transparent;
            box-shadow: none;
        }
    }

    

    .generate-img-btn {
        padding: 1rem 0.5rem;
        margin: 1rem auto;
    }

    // .generate-img-btn button {
    //     background: --base_orange;
    //     background: var(--button_gradient_orange);
    //     padding: 2rem;
    //     cursor: pointer;
    //     text-align: center;
    //     border-radius: var(--radius_global);
    //     font-family: var(--comic-font);
    //     text-transform: uppercase;
    //     text-shadow: 0 1px 3px black;
    //     border: 0;
    //     border-bottom: 2px solid #ee4e01;
    //     font-size: 1rem;
    //     color: #fff;
    // }

    .player-value--settings, .playername-settings-wrap {
        display: flex;
        align-items: flex-start;
    }

    .playername-settings-wrap {
        justify-content: space-between;
        flex-wrap: wrap;

        & > div {
            width: 100%;
        }
    }

    .player-value--settings > div {
        width: calc(33.33% - 0.5rem);
    }


    .parentWindow.showWatermark {
        overflow: hidden;
    }

    .card-wrap {
        border: 0;
        box-shadow: 0 3px 20px rgba(0,0,0,0.17);
    }

    
    @media(max-width:1000px) {
        .card-creator .container {
            flex-wrap: wrap;
            flex-direction: column-reverse;

            .card-creator--settings {
                width: 100%;
                padding: 0;
                position: relative;
            }

            // .card-creator--preview {
            //     width: 100%;
            //     position: relative;
            //     max-height: 460px;
            // }

            .card-creator--preview {
                transform: scale(0.75);
                transform-origin: center top;
                margin: 0 auto;
            }

        }
    }

    @media(max-width:640px) {
       

        .image-editing-sliders {
            flex-wrap: wrap;

            &>div {
                width: 100%;
                margin-bottom: 1rem;
            }
        }
    }

    @media(max-width:600px) {
        .button-style {
            width: 50%;
        }
    }

    @media(max-width:550px) {
        body, html {
            font-size: 14px;
        }

        input, select {
            height: 45px;
        }

        .player-setting.player-setting--name {
            width: 100%;
            flex: none;
        }
        .playername-settings-wrap, .image-editing-top {
            flex-wrap: wrap;

            &>* {
                width: 100%;
                margin-bottom: 1rem;
            }
        }

        .image-editing-top, .image-editing-sliders {
            flex-wrap: wrap;

            &>div {
                width: 100%;
                margin-bottom: 1rem;
            }
        }

        .card-styles--card-options > div {
            width: 100%;
        }

        .card-styles--card-options > div:not(.noborder-bottom) {
            width: 100%;
            border-bottom: 2px solid var(--body_bg);
            padding-bottom: 1rem;
        }
    }

    @media(max-width:450px) {
        .parentWindow {
            padding: 1rem 0rem;
            background: none;
            padding: 0;
            border: 0;
            width: 100%;
        }

        // .card-creator .container .card-creator--preview {
        //     transform: scale(0.65);
        //     transform-origin: center top;
        //     margin: 0 auto;
        // }   


    }


    #activate-card--images {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 11;
        opacity: 0;
    }

    .player-handle {
        width: 1rem;
        height: 1rem;

        &::after {
            content: '';
            width: 3rem;
            height: 3rem;
            background: transparent;
            position: absolute;
        }
    }

    .player-handle-tl {
        top: -0.5rem;
        left: -0.5rem;

        &::after {
            top: 0;
            left: 0;
        }
    }


    .player-handle-tr {
        top: -0.5rem;
        right: -0.5rem;
        &::after {
            top: 0;
            right: 0;
        }
    }


    .player-handle-br {
        bottom: -0.5rem;
        right: -0.5rem;
        &::after {
            bottom: 0;
            right: 0;
        }
    }


    .player-handle-bl {
        bottom: -0.5rem;
        left: -0.5rem;
        &::after {
            bottom: 0;
            left: 0;
        }
    }

    .Toplayersvg-output {
        width: 315px;
        height: 445px;
    }

    .card-creator.overflowHidden {
        overflow: hidden;
    }


.card-styles--menu {
    margin-bottom: 2rem;
    width: 100%;
}

.card-styles--menu ul {
    display: flex;
    background-color: var(--medium_blue);
    border: 2px solid var(--dark_blue);
    border-radius: var(--radius_global);
    width: 100%;
    flex-wrap: wrap;
}

/* .card-styles--menu ul > ul {
    padding-left: 0.75rem;
    margin: 0.5rem 0 1.5rem;
    border-left: 1px solid #ebedef;
    margin-left: 0.25rem;
} */

.card-styles--menu li {
    cursor: pointer;
}

.button-style {
    padding: 2rem;
    cursor: pointer;
    text-align: center;
    border-radius: var(--radius_global);
    font-family: var(--comic-font);
    text-transform: uppercase;
    text-shadow: 0 1px 3px black;
    width: 25%;
}

.button-style:not(.active):hover {
    color: #f7b886;
}

.button-style.active {
    background: rgb(255,136,40);
    background: linear-gradient(0deg, rgba(255,136,40,1) 0%, rgba(254,211,92,1) 100%);
    transform: scaleY(1.1);
    transform-origin: center top;
    border-bottom: 2px solid #ee4e01;
}

.button-style.active span {
    display: inline-block;
    transform: scaleY(0.9);
}

input[type="color"]::-webkit-color-swatch {
        border-radius: 50px;
        width: 20px!important;
        height: 20px;
        position: relative;
        max-width: 20px;
        border: none;
        cursor: pointer;
    }

input[type="color"] {
    background: white;
    width: 30px;
    border-radius: 50%;
    height: 30px;
    border: 1px solid #aaa;
    padding: 0 2px;
}

input, select {
    font-family: var(--base-font);
    font-weight: 400;
    background: var(--input_bg);
    color: var(--input_color);
    border:  var(--input_borderwidth) solid var(--input_bordercolor);
    border-radius: var(--radius_global);
    padding: 0rem 0.5rem;
    font-size: 0.9rem;
    height: 50px;
    width: 100%;
    font-weight: 600;
    max-width: 425px;
}

input:focus, select:focus {
    outline: none;
    border-color: #ccc;
    background: white;
}

label {
    font-weight: 700;
    font-size: 0.85rem;
    display: block;
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
    text-transform: capitalize;
}

.inputSlider {
    display: flex;
    width: 100%;
}

.inputSlider input[type=range] {
    flex: 1;
    -webkit-appearance: none;
    width: 100%;
    height: 2px;
    background: none;
    border-radius: var(--radius_global);
    outline: none;
    -webkit-transition: .2s;
    transition: opacity .2s;
    padding: 0;
}

.inputSlider input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: var(--blue_main);
  border: 1px solid var(--blue_main);
  cursor: pointer;
  transition: transform .2s ease;
}

.inputSlider input[type=range]:active::-webkit-slider-thumb {
    transform: scale(1.2);
}

.inputSlider input[type=range]::-moz-range-thumb {
    -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: var(--blue_main);
  border: 1px solid var(--blue_main);
  cursor: pointer;
  transition: transform .2s ease;
}

.inputSlider input[type=range]:active::-moz-range-thumb  {
    transform: scale(1.2);
}

.inputSlider input[type=number] {
    width: 75px;
    margin-left: 1rem;
}

.standalone-setting {
    padding: 1rem 0;
    border-radius: var(--radius_global);
    flex-wrap: wrap;
    margin-bottom: 2rem;

    input, label {
        width: 100%;
    }
}

.token-ficha--svg {
    width: 100%;
    max-width: 14px;
    height: auto;
    display: inline-block;
    vertical-align: middle;
    margin-left: 0.25rem;
    fill: #FFCA00;
}

.underline_span {
    text-decoration: underline;
    font-weight: 600;
}

.nav-showSettingsStep {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-radius: var(--radius_global);
    padding: var(--button_paddingx);
    background: #fff;
    box-shadow: 0 2px 7px rgba(0,0,0,0.17);

    & > div {
        cursor: pointer;
        flex: 1;
        font-weight: 600;
        font-size: 0.85rem;
        display: flex;
        align-items: center;
        padding: var(--button_paddingx);

        &:hover {
            color: var(--blue_main);
        }

        &.active {
            background: #e5f0ff;
            border-radius: var(--radius_global);
            color: var(--blue_main);
        }

        span {
            margin-left: 0.5rem;
        }
    }

}

@media(max-width: 1000px) {
    .nav-showSettingsStep {
        position: fixed;
        bottom: 0.5rem;
        left: 1rem;
        width: calc(100% - 2rem);
        z-index: 10;
        background: #424850;
        box-shadow: none;
    }
    .nav-showSettingsStep>div {
        justify-content: center;
        color: #fff;

        &.active {
            background: #fff;
        }
    }
    .card-creator .container {
        padding-bottom: 3rem;
    }
}



@media(max-width: 500px) {
    .nav-showSettingsStep > div {
        justify-content: center;
    }
    .nav-showSettingsStep > div span {
        display: none;
    }
}
    
</style>
